import axios from 'axios';

const apiUrl=process.env.REACT_APP_API_URL;

class Request {
    constructor() {
        this.baseURL = apiUrl;
        this.isRefreshing = false;
        this.refreshToken = undefined;
        this.failedRequests = [];
        this.client = axios.create({
            baseURL: apiUrl,
            headers: {
            }
        });
        this.onRequestFailure = this.onRequestFailure.bind(this);
        this.client.interceptors.request.use(this.beforeRequest);
        this.client.interceptors.response.use(
            this.onRequestSuccess, 
            this.onRequestFailure);
    }

    beforeRequest=(request)=> {

        let user = JSON.parse(localStorage.getItem('user'));
        let token='';
        if(user){
            token=user.token;
            this.refreshToken = user.refreshToken;
        } 
        request.headers={
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
        return request;
    }

    onRequestSuccess=(response)=> {
        if(response.data && response.data.status===2) return Promise.reject(response.data)
        return response.data;
    }

    async onRequestFailure(err) {
        let parseError = {}

        if (!err.response) {
            parseError={
                codigo:3,
                message:'No se ha podido establecer una conexión con el servidor, intente nuevamente en unos segundos'
            }
        } else {
            const { response } = err;
            if ((response.status === 401 || response.status === 403) && err && err.config && !err.config.__isRetryRequest) {
                if (this.isRefreshing) {
                    try {
                        const token = await new Promise((resolve, reject) => {
                            this.failedRequests.push({ resolve, reject });
                        });
                        err.config.headers.authorization = `Bearer ${token}`;
                        return this.client(err.config);
                    }
                    catch (e) {
                        return e;
                    }
                }
                this.isRefreshing = true;
                err.config.__isRetryRequest = true;
                return new Promise((resolve, reject) => {
                    this.refrescarToken().then((token) => {
                        err.config.headers.Authorization = `Bearer ${token}`;
                        this.isRefreshing = false;
                        this.processQueue(null, token);
                        resolve(this.client(err.config));
                    }).catch((e) => {
                        this.processQueue(e, null);
                        reject(err.response);
                    });
                });
            }
            parseError={
                codigo:err.response.status,
                message:err.response.statusText && err.response.statusText!==""?err.response.statusText:err.response.data.message?err.response.data.message:''
            }
        }
       
        throw parseError;
    }

    processQueue=(error, token = null)=> {
        this.failedRequests.forEach((prom) => {
            if (error) {
                prom.reject(error);
            } else {
                prom.resolve(token);
            }
        });
        this.failedRequests = [];
    }

    refrescarToken=()=>{
        return new Promise((resolve, reject) => {
            
                let url=apiUrl+'/auth/refreshtoken'            
                let res = fetch(url, {
                    method: 'POST',
                    data:{
                        refreshToken: this.refreshToken
                    },
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    redirect: 'follow',
                    referrer: 'no-referrer'
                }).then(res => res.json()).then(res => {           
                    localStorage.setItem('user', JSON.stringify(res));    
                    resolve(res.access_token);
                });
            
            }  );
    }
}


const request = new Request();

export default request.client;